export const DashboardRotes = {
  root: '/',
};

export const OffersRoutes = {
  root: '/offers',
  create: '/offers/create',
  update: '/offers/update/:offerId',
  details: '/offers/:offerId',
};

export const BookingsRoutes = {
  root: '/bookings',
  create: '/bookings/create',
  update: '/bookings/update/:bookingId',
  details: '/bookings/:bookingId',
  accountingExport: '/bookings/accounting-export',
};

export const AccountingExportsRoutes = {
  root: '/accounting-exports',
};

export const HotelsRoutes = {
  root: '/hotels',
  create: '/hotels/create',
  update: '/hotels/update/:hotelId',
  details: '/hotels/:hotelId',
};

export const CountriesRoutes = {
  root: '/countries',
  create: '/countries/create',
  update: '/countries/update/:countryId',
  details: '/countries/:countryId',
};
export const CategoriesRoutes = {
  root: '/categories',
  create: '/categories/create',
  update: '/categories/update/:categoryId',
  details: '/categories/:categoryId',
};
export const DiscountsRoutes = {
  root: '/discounts',
  create: '/discounts/create',
  update: '/discounts/update/:discountId',
  details: '/discounts/:discountId',
};
export const RegionsRoutes = {
  root: '/regions',
  create: '/regions/create',
  update: '/regions/update/:regionId',
  details: '/regions/:regionId',
};
export const TagsRoutes = {
  root: '/tags',
  create: '/tags/create',
  update: '/tags/update/:tagId',
  details: '/tags/:tagId',
};
export const OfferOptionsRoutes = {
  root: '/offer-options',
  create: '/offer-options/create',
  update: '/offer-options/update/:offerOptionId',
  details: '/offer-options/:offerOptionId',
};
export const CompaniesRoutes = {
  root: '/companies',
  create: '/companies/create',
  update: '/companies/update/:companyId',
  details: '/companies/:companyId',
};
export const PartiesRoutes = {
  root: '/parties',
  create: '/parties/create',
  update: '/parties/update/:partyId',
  details: '/parties/:partyId',
};
export const BankAccountsRoutes = {
  root: '/bank-accounts',
  create: '/bank-accounts/create',
  update: '/bank-accounts/update/:bankAccountId',
  details: '/bank-accounts/:bankAccountId',
};
export const BankDocumentsRoutes = {
  root: '/bank-documents',
  queue: '/bank-documents/queue',
  supplierPrepayments: '/bank-documents/supplier-prepayments',
  supplierPrepaymentReconciliation: '/bank-documents/supplier-prepayments/reconciliation',
  supplierPrepaymentApContractors: '/bank-documents/supplier-prepayments/ap-contractors',
  details: '/bank-documents/:bankDocumentId',
};
export const ReservationsRoutes = {
  root: '/reservations',
  create: '/reservations/create',
  update: '/reservations/update/:reservationId',
  details: '/reservations/:reservationId',
};
export const ContractTemplatesRoutes = {
  root: '/contract-templates',
  create: '/contract-templates/create',
  update: '/contract-templates/update/:contractTemplateId',
  details: '/contract-templates/:contractTemplateId',
};
export const InvoicesRoutes = {
  root: '/invoices',
  create: '/invoices/create',
  update: '/invoices/update/:invoiceId',
  details: '/invoices/:invoiceId',
};
export const ExpenseInvoicesRoutes = {
  root: '/expense-invoices', // Cost invoices list (received from suppliers)
  create: '/expense-invoices/create', // Create new expense invoice
  edit: '/expense-invoices/edit/:id', // Edit expense invoice
  details: '/expense-invoices/:id', // Cost invoice details
  import: '/expense-invoices/import', // Import cost invoice page
  importHistory: '/expense-invoices/import/history', // Import history page
  importJobDetail: '/expense-invoices/import/:importJobId', // Import job detail page
};
export const CashDocumentsRoutes = {
  root: '/cash-documents',
  create: '/cash-documents/create',
  update: '/cash-documents/edit/:id',
  details: '/cash-documents/:id',
};

export const KsefOutgoingRoutes = {
  root: '/ksef-outgoing',
};

export const UserManagementRoutes = {
  root: '/admin/users',
};

export const AuthRoutes = {
  login: '/login',
  verifyEmail: '/auth/verify-email',
};

export const ReportsRoutes = {
  root: '/reports',
  reservationPaymentReconciliation: '/reports/reservation-payment-reconciliation',
  unsettledBookingsAccounting: '/reports/unsettled-bookings-accounting',
  uninvoicedReservationPayments: '/reports/uninvoiced-reservation-payments',
};
